<template>
     <div v-if="!hide" class="form-network form-network-instagram" >
        <details open>
            <summary>{{ $t('dash.post-creator.form.instagram.visibility') }} <i class="fa-solid fa-caret-down"></i></summary>
            <div class="content-detail">
                <div class="type-switch" v-if="pagesSelectedIncludeConciergerie">
                    {{ $t('dash.post-creator.form.instagram.share-as-story') }}
                    <ComponentSwitch :value="draftInstance.form.networks.instagram.storification.active" :onChange="handlerSharePostInStory" :id="'switch-settings-advanced-instagram-1'"></ComponentSwitch>
                </div>
                <div class="type-switch" v-if="pagesSelectedIncludeConciergerie" :style="{opacity: draftInstance.form.networks.instagram.storification.active ? 1 : 0.6}">
                    {{ $t('dash.post-creator.form.instagram.share-story-facebook') }}
                    <ComponentSwitch :value="draftInstance.form.networks.instagram.storification.shareInFacebook" :onChange="handlerSharePostInStoryFacebook" :isDisable="!draftInstance.form.networks.instagram.storification.active" :id="'switch-settings-advanced-instagram-2'"></ComponentSwitch>
                </div>
                
                <div class="list-simple-btn">
                    <Tooltip 
                        :text="!nativeMode && $t('dash.post-creator.form.instagram.native-mode-only')"
                        :active="!nativeMode" 
                        position="bottom"
                        :classCustom="`type-btn-simple ${!nativeMode ? 'locked' : ''}`"
                        @click="openAddIdentifierMode"
                    >
                        <i class="fa-regular fa-circle-user"></i>
                        <p>
                            {{ $t('dash.post-creator.form.instagram.tagged-person') }} 
                            <span class="pink">({{ draftInstance.form.networks.instagram.personsIdentified.length }})</span>
                        </p>
                    </Tooltip>
                    
                    
                    <Tooltip 
                        :text="!nativeMode && 'Disponible seulement en mode natif'" 
                        :active="!nativeMode" 
                        position="bottom"
                        :classCustom="`
                            type-btn-simple 
                            ${!nativeMode ? 'locked' : ''}`
                        "
                        @click="openAddCollaboratorMode"
                    >
                        <i class="fa-regular fa-circle-user"></i>
                        <p>
                            {{ $t('dash.post-creator.form.instagram.collaborator') }} 
                            <span class="pink">({{ draftInstance.form.networks.instagram.collaborators.length || '0' }})</span>
                        </p>
                    </Tooltip>

                    <Tooltip 
                        :text="$t('dash.post-creator.form.instagram.native-mode-only')"
                        :active="!nativeMode" 
                        position="bottom"
                        :classCustom="`type-btn-simple ${!nativeMode ? 'locked' : ''}`"
                        @click="nativeMode && addMode('addPlaceMode')"
                    >
                        <i class="fa-solid fa-map-pin"></i>
                        <p>
                            {{ $t('dash.post-creator.form.instagram.place') }} 
                            <span class="pink">({{ draftInstance.form.networks.instagram.place ? '1' : '0' }})</span>
                        </p>            
                    </Tooltip>
                    <Tooltip 
                        :text="$t('dash.post-creator.form.instagram.native-mode-only')"
                        :active="!nativeMode" 
                        position="bottom"
                        :classCustom="`type-btn-simple ${!nativeMode ? 'locked' : ''}`"
                        @click="nativeMode && addMode('addMusicMode')"
                    >
                        <i class="fa-solid fa-music"></i>
                        <p>
                            {{ $t('dash.post-creator.form.instagram.music') }} 
                            <span class="pink">({{ draftInstance.form.networks.instagram.music ? '1' : '0' }})</span>
                        </p>
                    </Tooltip>

                    <Tooltip 
                        :text="$t('dash.post-creator.form.instagram.native-mode-only')"
                        :active="!nativeMode" 
                        position="bottom"
                        :classCustom="`type-btn-simple ${!nativeMode ? 'locked' : ''}`"
                        @click="nativeMode && addMode('addProductMode')"
                    >
                        <i class="fa-regular fa-bag-shopping"></i>
                        <p>
                            {{ $t('dash.post-creator.form.instagram.product') }} 
                            <span class="pink">({{ draftInstance.form.networks.instagram.products.length }})</span>
                        </p>
                    </Tooltip>
                </div> 
              
            </div>      
        </details>

        <details open v-if="showRatio">
            <summary>
                {{ $t('dash.post-creator.form.instagram.format') }} 
                <i class="fa-solid fa-caret-down"></i>
            </summary>
            <div class="content-detail">
                <div class="list-radio-btn" :class="{disable: ratioIsDisable}">
                    <div class="type-btn-simple" @click="changeRatio('auto')">
                        <i class="fa-regular fa-circle" :class="{'fa-solid fa-circle-dot' : draftInstance.form.networks.instagram.ratio =='auto'}"></i>
                        <p>Original</p>
                    </div>

                    <div class="type-btn-simple" @click="changeRatio('4:5')">
                        <i class="fa-regular fa-circle" :class="{'fa-solid fa-circle-dot' : draftInstance.form.networks.instagram.ratio =='4:5'}"></i>
                        <p>Ratio 4:5</p>
                    </div>
                    
                    <div class="type-btn-simple" @click="changeRatio('1:1')">
                        <i class="fa-regular fa-circle" :class="{'fa-solid fa-circle-dot' : !draftInstance.form.networks.instagram.ratio || draftInstance.form.networks.instagram.ratio =='1:1'}"></i>
                        <p>Ratio 1:1</p>
                    </div>

                    <div class="type-btn-simple" @click="changeRatio('16:9')">
                        <i class="fa-regular fa-circle" :class="{'fa-solid fa-circle-dot' : draftInstance.form.networks.instagram.ratio =='16:9'}"></i>
                        <p>Ratio 16:9</p>
                    </div>
                 
                  
                   
                </div>  
            </div>      
        </details>
    </div>
</template>

<script>
    import { EventBus } from '@/event-bus';
    import store from '@/store/index.js';
    import ComponentSwitch from '@/components/dash/utils/switch.vue'
    import SnippetNetwork from './../SnippetNetwork.vue'
    import minxinBot from '@/components/mixins/Bots.vue'
    import minxinPost from '@/components/mixins/Posts.vue'
    import { getFilesByNetwork } from './../../../utils'
    import Tooltip from '@/components/dash/tooltip/tooltipInit.vue'
    import { VueDraft } from '@mashupweb/draft-lib'

    export default {

        components: {
            ComponentSwitch,
            SnippetNetwork,
            Tooltip
        },
        mixins: [minxinBot,minxinPost],

        props: {
            hide : {
                type: Boolean,
                default: false
            },
            files:Object,
            idPageRenderNetworkSelected: {
                type: String,
                default: null
            },
            draftInstance: VueDraft
        },

        data() {
            return {
                inputModel:{
                    switchCustomSnippet: false,
                    urlImageSnippet: "",
                    titleSnippet: "",
                    descriptionSnippet: "",
                },

                lastModeSelected : undefined
            }
        },

        
        mounted() {
            EventBus.$on('eventSearchFromSelectPerson', this.searchPerson);
            EventBus.$on('eventClickSelectPerson', this.addPerson);
            EventBus.$on('eventRemoveSelectPerson', this.removePerson);

            EventBus.$on('eventSearchFromSelectPlace', this.searchPlace);
            EventBus.$on('eventClickSelectPlace', this.addPlace);
            EventBus.$on('eventRemoveSelectPlace', this.removePlace);

            EventBus.$on('eventSearchFromSelectMusic', this.searchMusic);
            EventBus.$on('eventClickSelectMusic', this.addMusic);
            EventBus.$on('eventRemoveSelectMusic', this.removeMusic);

            EventBus.$on('eventGetTrendShopsFromSelectProduct', this.getTrendShops);
            EventBus.$on('eventSearchShopsFromSelectProduct', this.searchShops);
            EventBus.$on('eventSearchProductFromSelectProduct', this.searchProduct);
            EventBus.$on('eventGetTrendProductsFromSelectProduct', this.getTrendProducts);   
            EventBus.$on('eventGetVariantsProductFromSelectProduct', this.getVariantsProduct);
            EventBus.$on('eventClickSelectProduct', this.addProduct);
            EventBus.$on('eventRemoveSelectProduct', this.removeProduct);


        },

        methods: {
           
            addMode(mode) {
                this.lastModeSelected = mode
                EventBus.$emit("postCreatorAddMode", mode);
            },
            async searchPerson(value,idEvent) {
                let page = this.pagesSelected.find(p => p.network == "instagram" && p.story_config && p.story_config.created)
                let result = []
                if (page) {
                    result = (await this.getMentionsByApi(page.id, value, false, true)).mentions
                }
                EventBus.$emit("resultSearchFromSelectPerson", result,idEvent)
            },
            addPerson(person) {
                console.log("addPerson")
                switch (this.lastModeSelected) {
                    case 'addIdentifierMode':
                        this.draftInstance.form.networks.instagram.personsIdentified = [...this.draftInstance.form.networks.instagram.personsIdentified.filter(p => p.id !== person.id),person]
                        break;
                    case 'addCollaboratorMode':
                        tthis.draftInstance.form.networks.instagram.collaborators = [...this.draftInstance.form.networks.instagram.collaborators.filter(p => p.id !== person.id),person]
                        break;
                }
            },
            removePerson(idPerson) {
                switch (this.lastModeSelected) {
                    case 'addIdentifierMode':
                        this.draftInstance.form.networks.instagram.personsIdentified = this.draftInstance.form.networks.instagram.personsIdentified.filter(p => p.id !== idPerson)
                        break;
                    case 'addCollaboratorMode':
                        this.draftInstance.form.networks.instagram.collaborators = this.draftInstance.form.networks.instagram.collaborators.filter(p => p.id !== idPerson)
                        break;
                }
            },

            openAddIdentifierMode() { 
                if (this.nativeMode) {
                    this.addMode('addIdentifierMode')
                }
            },

            openAddCollaboratorMode() {
                if (this.nativeMode) {
                    this.addMode('addCollaboratorMode')
                }
            },

            async searchPlace(network, value,idEvent) {
                if (network !== 'instagram') return
                let page = this.pagesSelected.find(p => p.network == 'instagram' && p.story_config && p.story_config.created)
                
                let result = []
                if (page) {
                    result = (await this.getLocation(page.id, value)).body.locations
                }
                EventBus.$emit("resultSearchFromSelectPlace", result, idEvent)
            },
            addPlace(network, place) {
                if (network !== 'instagram') return
                this.draftInstance.form.networks.instagram.place = place
            },
            removePlace(network) {
                if (network !== 'instagram') return
                this.draftInstance.form.networks.instagram.place = undefined
            },

            async searchMusic(value,idEvent) {
                let page = this.pagesSelected.find(p => p.network == "instagram" && p.story_config && p.story_config.created)
                let result = []
                if (page) {
                    result = (await this.getMusicInstagram(page.id, value, "music_in_feed")).body.musics
                }
                EventBus.$emit("resultSearchFromSelectMusic", result, idEvent)
            },
            addMusic(music) {
                this.draftInstance.form.networks.instagram.music = music
            },
            removeMusic() {
                this.draftInstance.form.networks.instagram.music = null
            },


            async getTrendShops(idEvent) {
                let page = this.pagesSelected.find(p => p.network == "instagram" && p.story_config && p.story_config.created)
                let result = []
                if (page) {
                    result = (await this.getTrendShopsInstagram(page.id)).body.shops
                }
                EventBus.$emit("resulttGetTrendShopFromSelectProduct", result, idEvent)
            },

            async searchShops(value,idEvent) {
                
                let page = this.pagesSelected.find(p => p.network == "instagram" && p.story_config && p.story_config.created)
                let result = []
                console.log("searchShops",page)
                if (page) {
                    result = (await this.searchShopsInstagram(page.id, value)).body.shops
                }
                EventBus.$emit("resultSearchShopFromSelectProduct", result, idEvent)
            },

            async searchProduct(shopId, value ,idEvent) {
                let page = this.pagesSelected.find(p => p.network == "instagram" && p.story_config && p.story_config.created)
                let result = []
                if (page) {
                    result = (await this.searchItemsShopInstagram(page.id, shopId , value)).body.items
                }
                EventBus.$emit("resultSearchProductFromSelectProduct", result, idEvent)
            },

            async getTrendProducts(shopId, idEvent) {
                let page = this.pagesSelected.find(p => p.network == "instagram" && p.story_config && p.story_config.created)
                let result = []
                if (page) {
                    result = (await this.getTrendItemsShopInstagram(page.id, shopId)).body.items	
                }
                EventBus.$emit("resultGetTrendProductsFromSelectProduct", result, idEvent)
            },
            
            async getVariantsProduct(productId, shopId, idEvent) {
                let page = this.pagesSelected.find(p => p.network == "instagram" && p.story_config && p.story_config.created)
                let result = []
                if (page) {
                    result = (await this.chooseItemShopInstagram(page.id, productId, shopId)).body.items	
                }
                EventBus.$emit("resultGetVariantsProductFromSelectProduct", result, idEvent)
            },

            addProduct(product) {
                this.draftInstance.form.networks.instagram.products = [...this.draftInstance.form.networks.instagram.products.filter(p => p.id !== product.id), product]

            },
            removeProduct(idProduct) {
                this.draftInstance.form.networks.instagram.products = this.draftInstance.form.networks.instagram.products.filter(p => p.id !== idProduct)
            },

            changeRatio(ratio) {
                this.draftInstance.form.networks.instagram.ratio = ratio
            },
            handlerSharePostInStory(state) {
                this.draftInstance.form.networks.instagram.storification.active = state
                if (!state) {
                    this.draftInstance.form.networks.instagram.storification.shareInFacebook = false
                }
            },
            handlerSharePostInStoryFacebook(state) {
                this.draftInstance.form.networks.instagram.storification.shareInFacebook = state

                if (state) {
                    this.draftInstance.form.networks.instagram.storification.active = true
                }
            }
        },

        computed: {
            allPages() {
                return this.$store.getters['selectPage/selectPageAllPages'];
            },
            pagesSelected() {
                return this.$store.getters['selectPage/selectPagePageSelected'].map(id => this.allPages[id]);
            },
            pagesSelectedIncludeConciergerie() {
                return this.pagesSelected.filter(page => page.network == 'instagram' && page.story_config && page.story_config.created).length
            },

            showRatio() {
                const medias = this.draftInstance.form.medias.getByNetwork('instagram')
                return medias.length > 1 || medias.first?.file.info.type2 === 'image'
            },

            nativeMode() {
                if (this.idPageRenderNetworkSelected) {
                    const page = this.allPages[this.idPageRenderNetworkSelected]
                    return page && page.network == 'instagram' && page.story_config && page.story_config.created
                }else{
                    return this.pagesSelected.some(p => p.network == 'instagram' && p.story_config && p.story_config.created)
                }
            }
        },


        beforeDestroy () {
            EventBus.$off('eventSearchFromSelectPerson', this.searchPerson);
            EventBus.$off('eventClickSelectPerson', this.addPerson);
            EventBus.$off('eventRemoveSelectPerson', this.removePerson);

            EventBus.$off('eventSearchFromSelectPlace', this.searchPlace);
            EventBus.$off('eventClickSelectPlace', this.addPlace);
            EventBus.$off('eventRemoveSelectPlace', this.removePlace);

            EventBus.$off('eventSearchFromSelectMusic', this.searchMusic);
            EventBus.$off('eventClickSelectMusic', this.addMusic);
            EventBus.$off('eventRemoveSelectMusic', this.removeMusic);


            
            EventBus.$off('eventGetTrendShopsFromSelectProduct', this.getTrendShops);
            EventBus.$off('eventSearchShopsFromSelectProduct', this.searchShops);
            EventBus.$off('eventSearchProductFromSelectProduct', this.searchProduct);
            EventBus.$off('eventGetTrendProductsFromSelectProduct', this.getTrendProducts);
            EventBus.$off('eventGetVariantsProductFromSelectProduct', this.getVariantsProduct);
            EventBus.$off('eventClickSelectProduct', this.addProduct);
            EventBus.$off('eventRemoveSelectProduct', this.removeProduct);
        }
        
    }
</script>